export default {
    metaData: (state) => {
        return state.meta;
      },
      productsList: (state) => {
        return state.products;
      },
}
